import { useRouter } from 'next/router';
import { useState } from 'react';

import styles from './styles.module.scss';
import Image from 'next/image';

import { PuffLoader } from 'react-spinners';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';

export default function DisplayCard({ listing }) {
  const router = useRouter();
  const [coverLoaded, setCoverLoaded] = useState(false);
  const { displayName, category, urlHandle, pfp, zip } = listing;

  function handleOpenVendor() {
    router.push(router.pathname + '/' + urlHandle);
  }
  
  return (
    <div className={styles.displayCard} onClick={handleOpenVendor}>
      <div>
        <div style={{ display: coverLoaded === false ? 'flex' : 'none' }}>
          <PuffLoader color="#424242" size={25} />
        </div>
        <Image
          sizes="auto auto"
          fill
          src={pfp}
          alt={displayName}
          onLoadingComplete={() => setCoverLoaded(true)}
        />
      </div>

      <div>
        <section>
          <h1>{displayName}</h1>
          <h2>{category}</h2>
        </section>
        <section>
          <h3>
            <FontAwesomeIcon icon={faLocationDot} id={styles.icon} />
            {zip}
          </h3>
        </section>
      </div>
    </div>
  );
}
